export default __webpack_public_path__ + "static/media/rid-03@2x.c1cf82b8.jpg";